/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    IdentityProviderSettingsListConfiguration,
    IdentityProviderSettingsListConfigurationFromJSON,
    IdentityProviderSettingsListConfigurationToJSON,
    IdentityProviderSettingsListItem,
    IdentityProviderSettingsListItemFromJSON,
    IdentityProviderSettingsListItemToJSON,
    IdentityProviderSettingsListQuery,
    IdentityProviderSettingsListQueryFromJSON,
    IdentityProviderSettingsListQueryToJSON,
} from '../models';

export interface ApiIdentityProviderSettingsIdentityProviderSettingsListDataPostRequest {
    identityProviderSettingsListQuery?: IdentityProviderSettingsListQuery;
}

/**
 * no description
 */
export class IdentityProviderSettingsListApi extends runtime.BaseAPI {

    /**
     */
    async apiIdentityProviderSettingsIdentityProviderSettingsListConfigurationGetRaw(): Promise<runtime.ApiResponse<IdentityProviderSettingsListConfiguration>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/IdentityProviderSettings/IdentityProviderSettingsList/Configuration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => IdentityProviderSettingsListConfigurationFromJSON(jsonValue));
    }

    /**
     */
    async apiIdentityProviderSettingsIdentityProviderSettingsListConfigurationGet(): Promise<IdentityProviderSettingsListConfiguration> {
        const response = await this.apiIdentityProviderSettingsIdentityProviderSettingsListConfigurationGetRaw();
        return await response.value();
    }

    /**
     */
    async apiIdentityProviderSettingsIdentityProviderSettingsListDataPostRaw(requestParameters: ApiIdentityProviderSettingsIdentityProviderSettingsListDataPostRequest): Promise<runtime.ApiResponse<Array<IdentityProviderSettingsListItem>>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/IdentityProviderSettings/IdentityProviderSettingsList/Data`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IdentityProviderSettingsListQueryToJSON(requestParameters.identityProviderSettingsListQuery),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IdentityProviderSettingsListItemFromJSON));
    }

    /**
     */
    async apiIdentityProviderSettingsIdentityProviderSettingsListDataPost(requestParameters: ApiIdentityProviderSettingsIdentityProviderSettingsListDataPostRequest): Promise<Array<IdentityProviderSettingsListItem>> {
        const response = await this.apiIdentityProviderSettingsIdentityProviderSettingsListDataPostRaw(requestParameters);
        return await response.value();
    }

}
